import Modal from 'components/Modal';
import InitialSignUpScreen from 'components/InitialSignUpScreen';
import { MemoryRouter, Route, useHistory, useLocation } from '@alltrails/shared/components/ReactRouter';
import LogIn from 'components/LogIn';
import CreateAccount from 'components/CreateAccount';
import logWebSignupModalShown from '@alltrails/analytics/events/logWebSignUpModalShown';
import CarouselDisplayTrigger from '@alltrails/analytics/enums/CarouselDisplayTrigger';
import { ReactNode, useEffect } from 'react';
import User from '@alltrails/shared/types/User';

type ModalProps = {
  heading?: ReactNode;
  isOpen: boolean;
  onRequestClose: () => void;
  onSuccess: (user: User) => void;
  redirectUrl?: string;
};

type SignupModalProps = ModalProps & {
  trigger?: CarouselDisplayTrigger;
};

function Content({ heading, isOpen, onRequestClose, redirectUrl, onSuccess }: ModalProps) {
  const history = useHistory();
  const location = useLocation();

  const goBack = location.pathname !== '/' ? () => history.push('/') : undefined;

  return (
    <Modal goBack={goBack} isOpen={isOpen} onRequestClose={onRequestClose}>
      <Route path="/" exact>
        <InitialSignUpScreen heading={heading} onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
      <Route path="/:locale?/login" exact>
        <LogIn heading={heading} onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
      <Route path="/:locale?/register" exact>
        <CreateAccount heading={heading} onSuccess={onSuccess} redirectUrl={redirectUrl} />
      </Route>
    </Modal>
  );
}

export default function SignupModal({ heading, isOpen, onRequestClose, onSuccess, redirectUrl, trigger }: SignupModalProps) {
  useEffect(() => {
    if (isOpen) {
      global.branch?.track('pageview', { signupModalTest: true });
      logWebSignupModalShown({ trigger });
    }
  }, [isOpen, trigger]);

  return (
    <MemoryRouter>
      <Content heading={heading} isOpen={isOpen} onRequestClose={onRequestClose} onSuccess={onSuccess} redirectUrl={redirectUrl} />
    </MemoryRouter>
  );
}
